const API_URL = String(
  process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
).replace(/\/$/, '');

export function pobierzToken() {
  return localStorage.getItem('token');
}

export async function apiFetch(sciezka, opcje = {}) {
  const token = pobierzToken();
  const headers = {
    ...(opcje.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(opcje.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_URL}${sciezka}`, { ...opcje, headers });

  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('uzytkownik');
    window.dispatchEvent(new Event('auth:logout'));
  }

  if (!response.ok) {
    let error = 'Wystąpił błąd.';
    try {
      const data = await response.json();
      error = data.error || error;
    } catch {}
    throw new Error(error);
  }

  const type = response.headers.get('content-type') || '';
  if (type.includes('application/json')) return response.json();
  return response;
}

export async function pobierzExcel(sciezka, nazwaPliku) {
  const response = await apiFetch(sciezka);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nazwaPliku;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
